import type { RumEvent } from '@datadog/browser-rum';

export function isCspViolationError(event: RumEvent) {
  return event.type === 'error' && event.error.source === 'report' && event.error.csp !== undefined;
}
